import { Router } from 'expo-router';

import { routes } from 'utils/routing';

/**
 * Swaps the offer detail modal for the full store locator.
 *
 * Both routes live under `(modals)`, so `replace` removes offer detail from the
 * stack in the same navigation that opens the locator. `navigate` would stack
 * the locator on top and leave the empty offer modal waiting underneath.
 *
 * `redirectUrl` returns to offer detail once a restaurant is chosen, so the
 * deeplink is re-evaluated against that restaurant.
 */
export function replaceOfferDetailWithStoreLocator(
  router: Pick<Router, 'replace'>,
  redirectUrl: string
): void {
  router.replace({
    pathname: routes.storeLocator as '/store-locator',
    params: { redirectUrl },
  });
}
